export const FETCH_RESULT_TN = 'FETCH_RESULT_TN';
export const LIST_RESULT_TN = 'tn';
export const DRAW_RESULT_TN = 'DRAW_RESULT_TN';

